"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CARDS_TO_STUDY_MAX_FIRST = void 0;
exports.CARDS_TO_STUDY_MAX_FIRST = 5000;
